export enum CountryCode {
  DE = 'de', // Deutschland
  AT = 'at', // Österreich
  CH = 'ch', // Schweiz
  DK = 'dk', // Dänemark
  PL = 'pl', // Polen
  CZ = 'cz', // Tschechien
  FR = 'fr', // Frankreich
  LU = 'lu', // Luxemburg
  BE = 'be', // Belgien
  NL = 'nl', // Niederlande
  IT = 'it', // Italien
  LI = 'li', // Liechtenstein
  SK = 'sk', // Slowakei
  HU = 'hu', // Ungarn
  SI = 'si', // Slowenien
}
